var _path, _path2;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgHomeIcon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 20,
    height: 20,
    viewBox: "0 0 20 20",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M7.08398 13.168C7.82314 13.7158 8.72209 14.0372 9.6916 14.0372C10.6611 14.0372 11.56 13.7158 12.2992 13.168",
    stroke: "#1C274C",
    strokeWidth: 2,
    strokeLinecap: "round"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M18.3841 9.86928V11.1914C18.3841 14.582 18.3841 16.2774 17.3657 17.3307C16.3475 18.3841 14.7084 18.3841 11.4305 18.3841H7.95364C4.67566 18.3841 3.03668 18.3841 2.01833 17.3307C1 16.2774 1 14.582 1 11.1914V9.86928C1 7.88019 1 6.88563 1.45129 6.06116C1.90258 5.23669 2.72707 4.72499 4.37602 3.7016L6.11443 2.62269C7.8575 1.5409 8.72906 1 9.69205 1C10.655 1 11.5266 1.5409 13.2697 2.62269L15.0081 3.70159C16.6571 4.72499 17.4815 5.23669 17.9328 6.06116",
    stroke: "#1C274C",
    strokeWidth: 2,
    strokeLinecap: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgHomeIcon);
export default __webpack_public_path__ + "static/media/home_icon.3d92a8112d8893f78993b79197935fd9.svg";
export { ForwardRef as ReactComponent };